{
  "privacyPolicy": "Privacy Policy",
  "importantDisclosures": "Important Disclosures",
  "termsOfUse": "Terms Of Use",
  "yourFinancialGuide": "Your Financial Education Guide",
  "whatWeOffer": "What We Offer",
  "ourBusinessOppurtunity": "Our Business Opportunity",
  "firstName": "First Name",
  "lastName": "Last Name",
  "emailAddress": "Email Address",
  "emailMe": "Email Me",
  "message": "Message",
  "messagePlaceholder": "Send a message to your Primerica Rep",
  "office": "Office",
  "mobile": "Mobile",
  "howCanIHelp": "How Can I Help?",
  "send": "Send",
  "scheduleAnAppointment": "Schedule an Appointment",
  "myServices": "My Services",
  "investmentsAndSavings": "Investments & Savings",
  "termLifeInsurance": "Term Life Insurance",
  "mortgageLoans": "Mortgage Loans",
  "mortgageBranchOffice": "Mortgage Branch Office",
  "seeImportantDisclosures": "Please see important disclosures below",
  "autoHomeOwners": "Auto & Homeowners Insurance Referral Program",
  "primericaBusinessOpportunity": "The Primerica Business Opportunity",
  "aboutMe": "About Me",
  "pfsInvestmentsRepUS": "PFS Investments Inc. Registered Representative",
  "pfsInvestmentsRepCN": "Representative of PFSL Investments Canada Ltd., mutual fund dealer",
  "lifeInsuranceRep": "Life Insurance Representative",
  "investmentAdviserRepUS": "Investment Adviser Representative",
  "investmentAdviserRepCN": "Financial Security Advisor Representing Primerica, a firm in the insurance of persons",
  "enterFirstName": "Enter your first name correctly",
  "enterLastName": "Enter your last name correctly",
  "enterEmail": "Enter your email correctly",
  "enterMessage": "Enter your message",
  "notAvailableInAll": "Not available in all states/provinces",
  "lifeLicense": "Life License",
  "importantDisclosuresLinkUS": "https://www.primerica.com/public/primerica_disclosures.html",
  "importantDisclosuresLinkCanada": "https://www.primericacanada.ca/public/canada/primerica_disclosures.html",
  "importantDisclosuresLink": "https://www.primerica.com/public/primerica_disclosures.html",
  "importantDisclosuresText": "Important Disclosures",
  "termsOfUseLinkUS": "https://www.primerica.com/public/terms_conditions.html",
  "termsOfUseLinkCanada": "https://www.primericacanada.ca/public/canada/terms_conditions.html",
  "termsOfUseLink": "https://www.primerica.com/public/terms_conditions.html",
  "termsOfUseText": "Terms of Use",
  "privacyPolicyLinkUS": "https://www.primerica.com/public/privacy/online_privacy_policy.html",
  "privacyPolicyLinkCanada": "https://www.primericacanada.ca/public/canada/canada_privacy.html",
  "privacyPolicyLink": "https://www.primerica.com/public/privacy/online_privacy_policy.html",
  "privacyPolicyText": "Privacy Policy"
}
